import {SessionStayPeriod} from '../feature/session/model';

export enum DateFormat {
    String = 'string',
    Date = 'date',
}

// const removeTimeFromDateUTC = (date: string) => {
//     if (date) {
//         const dateElements = date.split('-');
//         const year = parseInt(dateElements[0]);
//         const month = parseInt(dateElements[1])-1;
//         const day = parseInt(dateElements[2]);
//         const utcDate = Date.UTC(year, month, day, 0,0,0,0);

//         return new Date(utcDate);
//     }
// };

const removeTimeFromDate = (date: Date) => {
    return new Date(date.setHours(23, 59, 59, 0));
};

const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    return [year, month, day].join('-');
};

/*const addDaysToDate = (days: number, date: Date) => {
    const dateToFormat = DateUtil.formatDate(date);
    const extendedDate = removeTimeFromDate(date);
    extendedDate.setDate(extendedDate.getDate() + days);
    return extendedDate;
};*/

const addDaysToDate = (days: number, date: Date) => {
    const extendedDate = removeTimeFromDate(new Date(date));
    extendedDate?.setDate(extendedDate.getDate() + days);
    return extendedDate;
};

const getDateStringFromDate = (date: Date) => {
    return date.toISOString().split('T')[0];
};

const getDatesRange = (start: Date, end: Date, output: DateFormat) => {
    const dateArray = [];
    while (start <= end) {
        const dateToAdd = output === DateFormat.String ? getDateStringFromDate(start) : start;
        dateArray.push(dateToAdd);
        start = addDaysToDate(1, start);
    }
    return dateArray;
};

const getAllPossibleStayPeriod = (stayPeriod: SessionStayPeriod): SessionStayPeriod[] => {
    const results: SessionStayPeriod[] = [];
    const datesInString = getDatesRange(
        removeTimeFromDate(new Date(stayPeriod.arrivalDate)),
        removeTimeFromDate(new Date(stayPeriod.departureDate)),
        DateFormat.String,
    );
    for (let i = 1; i < datesInString.length; i++) {
        results.push({ arrivalDate: datesInString[i - 1].toString(), departureDate: datesInString[i].toString() });
    }
    return results; //TODO  CHECK FIX
};

const formatCalendarDate = (date: Date, language: string) => {
    return Intl.DateTimeFormat(language, {day: 'numeric', month: 'short', timeZone: 'UTC'}).format(date);
};

export const DateUtil = {
    getAllPossibleStayPeriod,
    addDaysToDate,
    getDateStringFromDate,
    getDatesRange,
    removeTimeFromDate,
    formatCalendarDate,
    formatDate
};
